import { render, staticRenderFns } from "./seriesCategories.vue?vue&type=template&id=53dfca0d&"
import script from "./seriesCategories.vue?vue&type=script&lang=js&"
export * from "./seriesCategories.vue?vue&type=script&lang=js&"
import style0 from "./seriesCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports